var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_623_2210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 40,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8002 49.3V11.7H11.2002V49.3H48.8002Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_623_2210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5867 45.3341C42.3805 40.0868 36.5995 36.5844 30.0002 36.5844M30.0002 36.5844C23.4008 36.5844 17.6199 40.0868 14.4137 45.3341M30.0002 36.5844C35.0406 36.5844 39.1268 32.4983 39.1268 27.4578C39.1268 22.4174 35.0406 18.3313 30.0002 18.3313C24.9597 18.3313 20.8736 22.4174 20.8736 27.4578C20.8736 32.4983 24.9597 36.5844 30.0002 36.5844ZM15.113 14.9653L14.4655 15.6129C12.7249 17.3534 11.7471 19.7141 11.7471 22.1757V38.8244C11.7471 41.2859 12.7249 43.6466 14.4655 45.3872L15.113 46.0347C16.8535 47.7753 19.2143 48.7531 21.6758 48.7531H38.3245C40.786 48.7531 43.1468 47.7753 44.8873 46.0347L45.5349 45.3872C47.2755 43.6466 48.2533 41.2859 48.2533 38.8244V22.1757C48.2533 19.7141 47.2755 17.3534 45.5349 15.6129L44.8873 14.9653C43.1468 13.2247 40.786 12.2469 38.3245 12.2469H21.6758C19.2143 12.2469 16.8535 13.2247 15.113 14.9653Z",
    stroke: "#F38D00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bce85926a0a53e9cb29b0abe3f39e57f.svg";
export { ForwardRef as ReactComponent };